import Component from '../../js/lib/component';
import anime from 'animejs';

const classList = {
  root: '.js-reviews',
  list: '.js-reviews-list',
  footer: '.js-reviews-footer',
  button: '.js-reviews-button'
};

export default class Reviews extends Component {
  init() {}
  events() {
    this.$.button.on('click', () => {
      this.$.button.prop('disabled', true);
      this.get().then(({ html, nextUrl }) => {
        if  (nextUrl) {
          this.$.button.data('url', nextUrl);
        } else {
          this.$.footer.remove();
        }


        this.add(html);
      });
    });
  }
  get(type) {
    return new Promise((resolve, reject) => {
      $.ajax(this.$.button.data('url'))
        .done(({ html, nextUrl }) => {
          resolve({ html, nextUrl });
        })
        .fail(error => {
          console.error(error);
          reject(error);
        })
        .always(() => {
          this.$.button.prop('disabled', false);
        });
    });
  }
  add(reviews) {
    this.$.list.append(reviews);
  }
}

Component.mount(Reviews, {
  name: 'Reviews',
  classList,
  state: {}
});
